import _ from 'underscore';
import { Partner } from '../partners/partner';

export default function PartnerService($http, $location, Upload) {
  const get = function get() {
    let partnerQueryParam, url;
    partnerQueryParam = $location.search().subdomain;

    if (partnerQueryParam) {
      url = `/partners/by_subdomain?subdomain=${partnerQueryParam}`;
    } else {
      url = '/partners/by_subdomain';
    }

    return $http.get(url).then(({ data }) => {
      return new Partner(data);
    });
  };

  const index = function index() {
    let url;
    url = '/partners/all';

    return $http
      .get(url)
      .then(({ data }) => data.map(partner => new Partner(partner)));
  };

  const update = function update(partner) {
    let params, partnerQueryParam;
    partnerQueryParam = $location.search().subdomain;
    params = { partner: partnerParams(partner) };

    if (partnerQueryParam) {
      params.subdomain = partnerQueryParam;
    }

    if (partner.newLogo) {
      return Upload.upload({
        url: '/partners',
        method: 'PUT',
        file: partner.newLogo,
        params
      }).then(({ data }) => new Partner(data));
    } else {
      return $http
        .put('/partners', params)
        .then(({ data }) => new Partner(data));
    }
  };

  const create = function create(partner) {
    if (partner.logo) {
      return Upload.upload({
        url: '/partners',
        method: 'POST',
        file: partner.logo,
        params: { partner: partnerParams(partner) }
      });
    } else {
      return $http.post('/partners', { partner: partnerParams(partner) });
    }
  };

  function partnerParams(partner) {
    return {
      click_tracker_macro: partner.clickTrackerMacro,
      custom_js_url: partner.customJsUrl,
      dco_enabled: partner.dcoEnabled,
      documentationUrl: partner.documentationUrl,
      hide_login: partner.hideLogin,
      language: partner.language,
      name: partner.name,
      navbar_background_color: partner.navbarBackgroundColor,
      navbar_text_color: partner.navbarTextColor,
      partner_type: partner.partnerType,
      rtb_version: partner.rtbVersion,
      subdomain: partner.subdomain,
      ad_types: partner.adTypes,
      siteIds: _.map(partner.sites, site => site.id)
    };
  }

  return {
    create,
    get,
    index,
    update
  };
}

PartnerService.$inject = ['$http', '$location', 'Upload'];
